export var SIZES = {
    tiny: 'tiny',
    small: 'small',
    medium: 'medium',
};
export var SKINS = {
    standard: 'standard',
    error: 'error',
    success: 'success',
    premium: 'premium',
    disabled: 'disabled',
    primary: 'primary',
};
export var WEIGHTS = {
    thin: 'thin',
    normal: 'normal',
    bold: 'bold',
};
//# sourceMappingURL=constants.js.map